"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableLinePoint = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const drawable_1 = require("./drawable");
class CollectionModelDrawableLinePoint extends drawable_1.MoveableDrawable {
    constructor(collectionModelDrawableState, drawableId, x, y, parentId) {
        super(collectionModelDrawableState, drawableId);
        this.x = x;
        this.y = y;
        this._parentId = parentId;
    }
    static isLinePoint(t) {
        return t instanceof CollectionModelDrawableLinePoint;
    }
    /** Lines can only be moved left/right */
    move(x, y) {
        const bounds = this.getPointInBounds(x, this.y);
        this.x = bounds.x;
        this.y = bounds.y;
    }
    get parent() {
        return this.drawableState.getDrawable(this._parentId);
    }
    remove() {
        super.remove();
        // Remove this line-point's parent too, unless it has already been removed
        if (this.drawableState.hasDrawable(this._parentId)) {
            this.parent.remove();
        }
    }
    get isInsightMeasurement() {
        return false;
    }
    isApprovableInsightDrawable() {
        return false;
    }
    get isVisible() {
        return true;
    }
    clone(newParentDrawableState) {
        return new CollectionModelDrawableLinePoint(newParentDrawableState, this.id, this.x, this.y, this._parentId);
    }
    equals(other) {
        return (other instanceof CollectionModelDrawableLinePoint
            && this._parentId === other._parentId
            && this.x === other.x
            && this.y === other.y
            && this._equals(other));
    }
}
exports.CollectionModelDrawableLinePoint = CollectionModelDrawableLinePoint;
tslib_1.__decorate([
    mobx_1.observable
], CollectionModelDrawableLinePoint.prototype, "x", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CollectionModelDrawableLinePoint.prototype, "y", void 0);
tslib_1.__decorate([
    mobx_1.action
], CollectionModelDrawableLinePoint.prototype, "move", null);
//# sourceMappingURL=line.point.drawable.js.map